function DictionaryOrganizationUnitVO(id, value, description, deleted, author, parent, children, versioned, version, originalElement) {
    this.id = id;
    this.value = value;
    this.description = description;
    this.deleted = deleted;
    this.author = author;
    this.parent = parent;
    this.children = children;
    this.versioned = versioned;
    this.version = version;
    this.originalElement = originalElement;

    var _typeContext = {
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {};

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
